export default {
  "content": "<g clip-path=\"url(#clip0_21112_848)\"><path d=\"M23.207 4.793a1 1 0 010 1.414l-4.5 4.5-1.414-1.414L20.086 6.5H9v11h6.086l-2.793-2.793 1.414-1.414 4.5 4.5a1 1 0 010 1.414l-4.5 4.5-1.414-1.414 2.793-2.793H8a1 1 0 01-1-1V13H0v-2h7V5.5a1 1 0 011-1h12.086l-2.793-2.793L18.707.293l4.5 4.5z\" fill=\"#7B61FF\"/></g><defs><clipPath id=\"clip0_21112_848\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};